import { ApiService } from '../../services/api_service';
import { checkFunktionFuerBereich } from '../../main/functions/checkFunktionFuerBereich';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
// import { DatenverwaltungGlossar } from '../../admin/bereiche/datenverwaltung/DatenverwaltungGlossar';
import { DatenverwaltungMedien } from '../../admin/bereiche/datenverwaltung/DatenverwaltungMedien';
import { EmissionsfaktorenHeizwerte } from './EmissionsfaktorenHeizwerte';
import { Foerderung } from './F\u00F6rderung';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { IDs } from '../../helpers/IDs';
import { Impressum } from './Impressum';
import { KontakteAnsprechpartner } from './KontaktAnsprechpartner';
import { lazyInject } from '../../services/inversify';
import { MehrsprachigkeitFaq } from '../../admin/bereiche/datenverwaltung/mehrsprachigkeit/MehrsprachigkeitFaq';
import { MehrsprachigkeitGlossar } from '../../admin/bereiche/datenverwaltung/mehrsprachigkeit/MehrsprachigkeitGlossar';
import { Nutzungsbedingungen } from './Nutzungsbedingungen';
import { PartnerTabs } from './PartnerTabs';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Sitemap } from './Sitemap';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { VerifizierungInfo } from './VerifizierungInfo';
import { Versionshistorie } from './Versionshistorie';
import { i18n } from '../../i18n/i18n';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';

interface InformationenHilfeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface InformationenHilfeState {
    tabIndex: number;
}

export class InformationenHilfe extends React.Component<InformationenHilfeProps, InformationenHilfeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxInformationenHilfe') || 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private devFeaturesMap: any = config.devFeaturesMap || {};

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_INFORMATIONEN_HILFE;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_INFORMATIONEN_HILFE;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxInformationenHilfe', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        // const allgemein: string = require('../../img/Allgemein.png');
        const bereich_key: string = (((this.props.data || {})[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const contentAllgemein = bereich_key === 'kultur'
            ? <div style={{ padding: 10 }}>{renderText('Allgemeine Erläuterungen', this.props.data)}</div>
            : <div style={{ padding: 10 }}>{renderText('Allgemeine Erläuterungen (Handwerk)', this.props.data)}</div>
        // <img src={allgemein} alt='allgemein' width={762} style={{ marginTop: 20, marginLeft: 10 }} />;
        const disabledFaq: boolean = !this.devFeaturesMap.N214_FAQ;
        const disabledKontakte: boolean = !checkFunktionFuerBereich('InformationenHilfe_Kontakte', bereich_key);
        const disabledMedien: boolean = !checkFunktionFuerBereich('InformationenHilfe_Medien', bereich_key);
        const disabledPartner: boolean = false; // !this.apiService.isAdmin() && this.apiService.getUsername() !== 'yang.wang@wips-home.de';

        const tabRoutings: any[] = [
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_ERLAEUTERUNGEN },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_SITEMAP },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_FAQ },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_GLOSSAR },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_FOERDERUNG },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_MEDIEN },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_EMISSIONSFAKTOREN_HEIZWERTE },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_VERSIONSHISTORIE },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_VERIFIZIERUNG },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_KONTAKTE },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN },
            { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_IMPRESSUM },
        ];

        return (
            <Tabs
                className='tabs-informationen_hilfe'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxInformationenHilfe', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{display: 'none'}}>
                    <Tab>{i18n('Allgemeine Erläuterungen', 'tab')}</Tab>
                    <Tab>{i18n('Sitemap', 'tab')}</Tab>
                    <Tab disabled={disabledFaq}>{i18n('FAQ', 'tab')}</Tab>
                    <Tab>{i18n('Glossar', 'tab')}</Tab>
                    <Tab>{i18n('Förderung', 'tab')}</Tab>
                    <Tab disabled={disabledMedien}>{i18n('Medien / Anleitungen', 'tab')}</Tab>
                    <Tab>{i18n('Emissionsfaktoren / Heizwerte', 'tab')}</Tab>
                    <Tab>{i18n('Versionshistorie', 'tab')}</Tab>
                    <Tab>{i18n('Verifizierung / Auszeichnungen', 'tab')}</Tab>
                    <Tab disabled={disabledKontakte}>{i18n('Kontakt / Unterstützung', 'tab')}</Tab>
                    <Tab disabled={disabledPartner}>{i18n('Partner:innen', 'tab')}</Tab>
                    <Tab>{i18n('Nutzungsbedingungen / Datenschutz', 'tab')}</Tab>
                    <Tab>{i18n('Impressum', 'tab')}</Tab>
                </TabList>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0
                    }}
                >
                    {/*getDefaultHelpIcon('pageAllgemeineErlaeuterungen', 'Hilfe zu den allgemeinen Erläuterungen', this.props.data)*/}
                    {contentAllgemein}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0
                    }}
                >
                    {/*getDefaultHelpIcon('pageSitemap', 'Hilfe zur Sitemap', this.props.data)*/}
                    <Sitemap
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 2 ? 1 : 0
                    }}
                >
                    {!disabledFaq &&
                        <MehrsprachigkeitFaq data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 3 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageGlossar', 'Hilfe zum Glossar', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <MehrsprachigkeitGlossar data={this.props.data} />
                    {/*<DatenverwaltungGlossar data={this.props.data} />*/}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 4 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageFoerderung', 'Hilfe zur Förderung', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <Foerderung data={this.props.data} />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 5 ? 1 : 0
                    }}
                >
                    {!disabledMedien && <>
                        {getDefaultHelpIcon('pageMedien', 'Hilfe zu Medien/Anleitungen', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenverwaltungMedien />
                    </>}
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 6 ? 1 : 0
                    }}
                >
                    {getDefaultHelpIcon('pageEmissionsfaktorenHeizwerte', 'Hilfe zu Emissionsfaktoren / Heizwerte', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <EmissionsfaktorenHeizwerte data={this.props.data} />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 7 ? 1 : 0 }}>
                    <div style={{ padding: 20, paddingTop: 0 }}>
                        <Versionshistorie
                            data={this.props.data}
                            openFirstItem
                        />
                    </div>
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 8 ? 1 : 0 }}>
                    {/*getDefaultHelpIcon('pageNutzungsbediungungen', 'Hilfe zu den Nutzungsbediungungen', this.props.data)*/}
                    <VerifizierungInfo data={this.props.data} />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 9 ? 1 : 0 }}>
                    {/*getDefaultHelpIcon('pageKontakteAnsprechpartner', 'Hilfe zu Kontakte / Ansprechpartner', this.props.data)*/}
                    {!disabledKontakte &&
                        <KontakteAnsprechpartner data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 10 ? 1 : 0
                    }}
                >
                    {!disabledPartner && <>
                        {getDefaultHelpIcon('pagePartnerTabs', 'Hilfe zu Partner:innen', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <PartnerTabs
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    </>}
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 11 ? 1 : 0 }}>
                    {/*getDefaultHelpIcon('pageNutzungsbediungungen', 'Hilfe zu den Nutzungsbediungungen', this.props.data)*/}
                    <Nutzungsbedingungen data={this.props.data} />
                </TabPanel>
                <TabPanel style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 12 ? 1 : 0 }}>
                    {/*getDefaultHelpIcon('pageImpressum', 'Hilfe zum Impressum', this.props.data)*/}
                    <Impressum data={this.props.data} />
                </TabPanel>
            </Tabs>
        );
    }
}
